module.exports = __webpack_public_path__ + "img/kma_gallery7.0631c038.jpg";